import { Component, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY, COLOR_PRIMARY_CONTRAST_500 } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { ProductCategoryDataComponent } from '../product-category-data/product-category-data.component';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.scss'],
})
export class ProductCategoryComponent {
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(
    NavigationItemLabel.settings,
  );
  @ViewChild(ProductCategoryDataComponent) data_component?: ProductCategoryDataComponent;

  constructor(private utils_service: UtilsService, private navigation_service: NavigationService, private meta: Meta) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
  }

  ngOnInit(): void {
    this.meta.updateTag({ content: COLOR_PRIMARY_CONTRAST_500 }, 'name=theme-color');
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }

  onRefresh(): void {
    this.data_component?.onRefresh();
  }
}
